<template>
  <div>
    <template v-for="(threeMonths, i) in chunkedOrderedYearMonths">
      <div
        :key="i"
        :data-test="`months-${i}`"
        class="boss-calendar-row"
      >
        <template v-for="(month, j) in threeMonths">
          <div
            :key="`${i}-${j}`"
            class="boss-calendar-one-month"
          >
            <interview-candidate-date-calendar-month
              :key="`${i}-${j}`"
              :target-year="month.year"
              :target-month="month.month"
              :schedule="schedule"
              :candidates="candidates"
              @changeNgDateCalendar="changeNgDate"
            />
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import InterviewCandidateDateCalendarMonth from '@/components/molecules/InterviewCandidateDateCalendarMonth'
import dayjs from 'dayjs'
import _ from 'lodash'

export default {
  components: {
    InterviewCandidateDateCalendarMonth
  },
  props: {
    schedule: {
      type: Object,
      required: true
    }
  },
  computed: {
    monthSize: () => 12,
    // 今月始まりの12ヶ月分の3 * 4のchunkした配列. 例) [[{year: 2021, month: 11}, {year: 2021, month: 12}, {year: 2022, month: 1}], [{year: 2022, month: 2}, ...]
    chunkedOrderedYearMonths () {
      return _.chunk([...Array(this.monthSize)]
        .map((_, i) => {
          const yearMonth = dayjs().add(i, 'month')
          return {
            year: yearMonth.get('year'),
            month: yearMonth.get('month') + 1 // 月は0始まりのため
          }
        }), 3)
    },
    // 設定可能開始日
    settingStartDate () {
      return dayjs().startOf('date').add(this.schedule.startDay, 'days')
    },
    // ※面接候補日となり得る日数(今月を含めた12ヶ月のカレンダーを表示しているため、12ヶ月後の最終日と現在の差分日数にあたるもの. 現在日当日は含まれないため + 1 ）例）今日が2021/9/10の場合、2022/08/31までの日数を返す
    possibilityCandidatesSize () {
      return dayjs().add(11, 'M').endOf('M').diff(dayjs(), 'days') + 1
    },
    // 面接候補日（NGを除く設定可能開始日から10日以内）
    candidates () {
      return [...Array(this.possibilityCandidatesSize)]
        .map((_, i) => i)
        .reduce((acc, i) => {
          const targetDate = this.settingStartDate.clone().add(i, 'day')
          if (acc.length < 10 && !this.schedule.ngDates.some(ngDate => dayjs(ngDate).isSame(targetDate))) {
            acc.push(targetDate)
          }
          return acc
        }, [])
    }
  },
  methods: {
    changeNgDate (isNg, selectedDate) {
      this.$emit('changeNgDateCalendarEdit', isNg, selectedDate)
    }
  }
}
</script>
